import React from "react";
import { estadosPagoOptions } from "../constants";

export default function PagosFilters({ filtros, setFiltros, limpiarFiltros, metodos = [] }) {
  const onChange = (key, value) => setFiltros((prev) => ({ ...prev, [key]: value }));

  return (
    <div className="management-card pagos-filters management-filters-card mb-3">
      <div className="row g-2 align-items-end">
        <div className="col-12 col-md-3">
          <label className="form-label management-label">Buscar</label>
          <input
            type="text"
            className="form-control"
            placeholder="Estudiante, referencia o codigo"
            value={filtros.search}
            onChange={(e) => onChange("search", e.target.value)}
          />
        </div>

        <div className="col-6 col-md-3">
          <label className="form-label management-label">Estado pago</label>
          <select
            className="form-select"
            value={filtros.estado_pago}
            onChange={(e) => onChange("estado_pago", e.target.value)}
          >
            <option value="all">Todos</option>
            {estadosPagoOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-6 col-md-3">
          <label className="form-label management-label">Metodo</label>
          <select
            className="form-select"
            value={filtros.metodo_pago}
            onChange={(e) => onChange("metodo_pago", e.target.value)}
          >
            <option value="all">Todos</option>
            {metodos.map((m) => (
              <option key={m.id} value={m.nombre}>
                {m.nombre}
              </option>
            ))}
          </select>
        </div>

        <div className="col-6 col-md-3">
          <label className="form-label management-label">Tipo de pago</label>
          <select
            className="form-select"
            value={filtros.tipo_pago || "all"}
            onChange={(e) => onChange("tipo_pago", e.target.value)}
          >
            <option value="all">Todos</option>
            <option value="matricula">Matrícula</option>
            <option value="cargos">Cargos adicionales</option>
          </select>
        </div>

        <div className="col-6 col-md-3">
          <label className="form-label management-label">Fecha desde</label>
          <input
            type="date"
            className="form-control"
            value={filtros.fecha_desde}
            onChange={(e) => onChange("fecha_desde", e.target.value)}
          />
        </div>

        <div className="col-6 col-md-3">
          <label className="form-label management-label">Fecha hasta</label>
          <input
            type="date"
            className="form-control"
            value={filtros.fecha_hasta}
            onChange={(e) => onChange("fecha_hasta", e.target.value)}
          />
        </div>

        <div className="col-6 col-md-3">
          <label className="form-label management-label">Comprobante</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.comprobante}
              onChange={(e) => onChange("comprobante", e.target.value)}
            >
              <option value="all">Todos</option>
              <option value="with">Con comprobante</option>
              <option value="without">Sin comprobante</option>
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
